import { useLocation } from "react-router";
import { styled } from "styled-components";

import { ActionButtonItem, BriefingIcon } from "common/components";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useGo } from "common/utilities/useGo";
import { useTranslate } from "common/utilities/useTranslate";
import { getUserRole } from "domains/authentication/selectors";
import { callsToActionSlice } from "domains/callsToAction/slice";
import { iconStyle } from "domains/topicDetail/components/actionButtons/iconStyle";
import { UserRole } from "entities/permissions/constants";
import { getCanAccessBriefing } from "entities/permissions/selectors";

export const BriefingActionButton = () => {
  const dispatch = useDispatch();
  const go = useGo();
  const { pathname } = useLocation();
  const canAccessBriefing = useSelector(getCanAccessBriefing);
  const userRole = useSelector(getUserRole);
  const translate = useTranslate();

  return (
    <ActionButtonItem
      advertisementLabelText={userRole === UserRole.Public ? translate("app.role.premium") : undefined}
      dataTitle="topic-briefing-button"
      icon={<StyledIcon />}
      label={translate("app.topic.actions.briefing")}
      onClick={() =>
        canAccessBriefing ? go(`${pathname}/briefing`) : dispatch(callsToActionSlice.actions.revive("cta-briefing-1"))
      }
    />
  );
};

const StyledIcon = styled(BriefingIcon)`
  ${iconStyle}
`;
